import SearchIcon from "@mui/icons-material/Search";
import {
	Box,
	InputAdornment,
	Stack,
	TextField,
	Typography,
} from "@mui/material";
import { useExtractionsQuery } from "Extractions/Api/Queries/useExtractionsQuery";
import { ExtractionsTable } from "Extractions/Components/ExtractionsTable";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";
import { type FC, useCallback, useEffect, useState } from "react";

export const ExtractionsPage: FC = () => {
	const [searchQuery, setSearchQuery] = useState("");
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(25);

	// Reset page to 0 when search query changes
	useEffect(() => {
		setPage(0);
	}, [searchQuery]);

	const offset = page * rowsPerPage;
	const { data, isLoading } = useExtractionsQuery(offset, rowsPerPage, searchQuery);
	const extractions = data?.items ?? [];
	const totalCount = data?.totalCount ?? 0;

	const handlePageChange = useCallback(
		(newPage: number, newRowsPerPage: number) => {
			setPage(newPage);
			setRowsPerPage(newRowsPerPage);
		},
		[],
	);

	return (
		<AuthenticatedLayout title="Extractions">
			<Stack spacing={2}>
				<Typography variant="h4">Extractions</Typography>
				<Stack direction="row" spacing={2} alignItems="center">
					<TextField
						fullWidth
						placeholder="Search by user, configuration, or tenant..."
						value={searchQuery}
						onChange={(e) => setSearchQuery(e.target.value)}
						slotProps={{
							input: {
								startAdornment: (
									<InputAdornment position="start">
										<SearchIcon />
									</InputAdornment>
								),
							},
						}}
						size="small"
					/>
				</Stack>
				<Box>
					<ExtractionsTable
						extractions={extractions}
						searchQuery={searchQuery}
						isLoading={isLoading}
						totalCount={totalCount}
						onPageChange={handlePageChange}
					/>
				</Box>
			</Stack>
		</AuthenticatedLayout>
	);
};
